

const stripHtml = (html = '') => {
    if (typeof html !== 'string') return String(html ?? '')
    return html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim()
}

/**
 * Builds a hierarchical list from a flat array of categories
 * @param {Array} flatCategories - Array of all categories
 * @param {string|number|null} excludeId - ID to exclude (and its children) to prevent circular dependency
 * @returns {Array} Flattened array with indentation levels
 */
export const buildHierarchicalOptions = (flatCategories, excludeId = null) => {
    if (!flatCategories || !Array.isArray(flatCategories)) return [];

    const map = {};
    const roots = [];

    // 1. Create a map and initialize children to avoid stale API data
    flatCategories.forEach((cat) => {
        map[cat.id] = { ...cat, children: [] };
    });

    // 2. Build the tree by linking parents and children
    flatCategories.forEach((cat) => {
        const item = map[cat.id];
        if (cat.parent_id && map[cat.parent_id]) {
            map[cat.parent_id].children.push(item);
        } else if (!cat.parent_id) {
            roots.push(item);
        }
    });

    // 3. Helper to flatten and add indentation, with exclusion check
    const flatten = (items, depth = 0) => {
        let result = [];
        items.forEach((item) => {
            // Stop if this is the excluded ID
            if (String(item.id) === String(excludeId)) return;

            const prefix = depth > 0 ? "— ".repeat(depth) : "";
            const nameAr = prefix + (item.name?.ar || "");
            const nameEn = prefix + (item.name?.en || "");

            result.push({
                ...item,
                name: { ...item.name, ar: nameAr, en: nameEn },
            });

            if (item.children && item.children.length > 0) {
                result = result.concat(flatten(item.children, depth + 1));
            }
        });
        return result;
    };

    return flatten(roots);
};

export const makePreview = (htmlOrText, truncateLength = 14) => {
    const txt = stripHtml(htmlOrText)
    if (!txt) return '—'
    return txt.length > truncateLength ? txt.slice(0, truncateLength) + '...' : txt
}


// Format date nicely
export const formatDate = (dateString) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    })
}

export const getOrCreateDeviceId = () => {
    let deviceId = localStorage.getItem('deviceId');

    if (!deviceId) {
        try {
            deviceId = crypto.randomUUID();
        } catch (error) {
            deviceId = `${Date.now()}-${Math.random().toString(36).substring(2, 15)}${Math.random().toString(36).substring(2, 15)}`;
        }
        localStorage.setItem('deviceId', deviceId);
    }

    return deviceId;
};

